<!--签署密码-->
<template>
  <!--签署密码设置-->
  <div>
      <p class="title-label">签署密码状态：<el-switch active-color="#ec1c1c" @change="handleSwitchChange" :value="selectSwitch" /><span class="forget" @click="isForget = true">忘记密码？</span></p>
      <span>提示：开启签署密码之后，每次在进行签署时，都需要输入签署密码进行身份验证，进一步保障您的账户安全。</span>
    <!-- 密码设置提示弹窗 -->
    <el-dialog title="提示" :visible.sync="closeAplCodeVisible" width="30%">
      <p>确定关闭当前合同手写签字校验？</p>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeAplCodeVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" size="mini" @click="closeAplCodeFn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 身份验证弹窗 -->
    <el-dialog title="身份验证" :visible.sync="isForget">
      <el-form
        :model="setPwdParam"
        :rules="rules"
        ref="setPwdForm"
        label-width="25%"
      >
        <el-form-item style="margin-bottom: 30px">
          <span class="hint"
            >{{stepPwd === 1 ? '设置签署密码时，需要先验证您的身份' :'请设置并确认您的签署密码'}}</span>
        </el-form-item>
        <template v-if="stepPwd === 1">
          <el-form-item label="企业联系人手机号码">
            <el-row>
              <el-col :span="10">
                <el-input :value="setPwdParam.targetId" :disabled="true" />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="imgCode" label="图形验证码">
            <el-row>
              <el-col :span="10"
                ><el-input
                  v-model="setPwdParam.imgCode"
                  placeholder="图形验证码"
              /></el-col>
              <el-col :span="14" style="padding-left: 40px">
                <div class="img-code">
                  <img-auth
                    ref="setPwdImgAuth"
                    :verify-type="11"
                    size="small"
                    key="setPwdImgAuth"
                  />
                </div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="noteCode" label="短信验证码">
            <el-row>
              <el-col :span="10"
                ><el-input
                  v-model="setPwdParam.noteCode"
                  placeholder="短信验证码"
              /></el-col>
              <el-col :span="14" style="padding-left: 40px">
                <el-button type="primary" v-if="countdown.start" disabled
                  ><countdown
                    v-model="countdown.value"
                    :start="countdown.start"
                    key="count"
                /></el-button>
                <el-button
                  v-else
                  @click="sendNoteAuthCode"
                   type="primary"
                  key="sendAuth"
                  >发送验证码</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button @click="isForget = false" style="width: 35%">取消</el-button>
            <el-button
              @click="handleNextStap"
              type="primary"
              style="width: 35%"
              >下一步</el-button
            >
          </el-form-item>
          <p style="text-align:center;">无法填写验证信息，请拨打400-808-9187联系客服处理</p>
        </template>
        <template v-if="stepPwd === 2">
          <el-form-item prop="signPwd" label="签署密码">
            <el-row>
              <el-col :span="10"
                ><el-input
                  v-model="setPwdParam.signPwd"
                  placeholder="签署密码"
              /></el-col>
            </el-row>
          </el-form-item>

          <el-form-item prop="rSignPwd" label="再次确认签署密码">
            <el-row>
              <el-col :span="10"
                ><el-input
                  v-model="setPwdParam.rSignPwd"
                  type="password"
                  placeholder="再次确认签署密码"
              /></el-col>
            </el-row>
          </el-form-item>

          <el-form-item>
            <el-row>
              <el-col :span="10">
                <el-button @click="handleCancelSetPwd" style="width: 35%"
                  >取消</el-button
                >
                <el-button
                  @click="saveSignPwd"
                  type="primary"
                  style="width: 35%"
                  >确认</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
        </template>
      </el-form>
    </el-dialog>
    <!--密码开关验证弹窗-->
    <el-dialog
      title="签字密码管理"
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :show-close="false"
      @open="flushImageCode"
    >
      <el-form
        :model="signPwdSwitchParam"
        :rules="switchRules"
        size="small"
        ref="pwdSwitch"
      >
        <el-form-item
          prop="signPwd"
          label="输入您的签署密码来完成启用/禁用操作"
        >
          <el-input
            v-model="signPwdSwitchParam.signPwd"
            type="password"
            placeholder="签字密码"
          />
        </el-form-item>
        <el-form-item prop="imgCode">
          <el-input
            v-model="signPwdSwitchParam.imgCode"
            placeholder="图形验证码"
          >
            <span
              slot="append"
              class="img-code"
              style="display: inline-block; margin: 0 -20px"
            >
              <img-auth
                ref="pwdSwithImgAuth"
                :verify-type="11"
                size="mini"
                key="pwdSwithImgAuth"
              />
            </span>
          </el-input>
        </el-form-item>
        <el-form-item class="text-center">
          <el-button @click="setPWdSwitch" type="primary">确认</el-button>
          <el-button @click="handleCancelSwitch">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  postSendCode,
  secSignInfo,
  ApiMethods,
} from "../../assets/js/http-serve/http-methods";
import SecurityController from "../../assets/js/http-serve/securityController";
import { imgAuth, noteAuth, password } from "../../assets/js/lib/valid-methods";
import Countdown from "../../components/countdown/index";
import ImgAuth from "../../components/img-auth/img-auth";
import { mapGetters } from "vuex";

export default {
  components: { Countdown, ImgAuth },
  data () {
    return {
      // 签署密码信息
      signPwdInfo: {
        legalMobilePhone: "",
        mobile: "",
        signPwdFlag: 0,
        signPwdStatus: 0
      },
      // 打开或关闭签署密码参数和验证
      signPwdSwitchParam: { signPwd: "", randomCode: "", imgCode: "" },
      switchRules: {
        signPwd: [{ validator: password, trigger: "blur" }],
        imgCode: [{ validator: imgAuth, trigger: "blur" }]
      },
      // 打开或关闭签署密码状态
      selectSwitch: false,
      dialogVisible: false,
      // 设置密码参数
      setPwdParam: {
        targetId: "",
        signPwd: "",
        rSignPwd: "",
        imgCode: "",
        noteCode: "",
        ts: "",
        sign: ""
      },
      rules: {
        // 验证信息
        imgCode: [{ validator: imgAuth, trigger: "blur" }],
        noteCode: [{ validator: noteAuth, trigger: "blur" }],
        signPwd: [
          {
            validator: this.$validator.required,
            message: "请输入签署密码",
            trigger: "change"
          },
          {
            validator: this.$validator.lengthRank,
            minLength: 6,
            maxLength: 16,
            message: "请输入6-16位",
            trigger: "change"
          },
          {
            validator: this.$validator.password,
            message: "密码不能是纯数字且不能有空格",
            trigger: "change"
          }
        ],
        rSignPwd: [{ validator: this.resPassword, trigger: "change" }]
      },
      isForget: false,
      stepPwd: 1,
      // 倒计时
      countdown: { value: 120, start: false },
      loading: null,
      aplCode: '', //apl编号
      closeAplCodeVisible: false,
      errorAplCodeTip: false, //未查询到编号提示
    };
  },
  computed: {
    ...mapGetters([
      'allAuthUser'
    ]),
    accountInfoVO () {
      if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
        return this.allAuthUser.accountInfoVO;
      }
      return {};
    }
  },
  mounted () {
    this.getSignPwdInfo();
  },
  watch: {
    "countdown.value" (val) {
      if (val === 0) {
        this.countdown.start = false;
        this.countdown.value = 120;
      }
    },
    isForget (val) {
      if (val) {
        this.setPwdParam.targetId = this.signPwdInfo.legalMobilePhone;
      } else {
        this.handleCancelSetPwd();
      }
    }
  },
  methods: {
    //查询apl编号
    queryAplCodeFn () {
      ApiMethods.UserApplySignController.commentsFindByApplyNo({
        applyNo: this.aplCode,
      }).then(res => {
        const data = res.data
        if (data) {
          // if (data.dealType === 17 || data.dealType === 20) return this.closeAplBatch()
          const REG = /^APL.*/
          if (!REG.test(this.aplCode)) return this.closeAplBatch()
          this.errorAplCodeTip = false;
          this.closeAplCodeVisible = true;
        } else {
          this.errorAplCodeTip = true;
        }
      })
    },
    /** 关闭批量签业务 */
    closeAplBatch () {
      const _this = this;
      _this.$confirm("确定关闭当前合同手写签字校验？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ApiMethods.UserApplySignController.batchSignWriteAiSwitch({
            businessNo: _this.aplCode,
            flag: 1,
          }).then(res => {
            if (!res.success) return _this.$message.error(res.description)
            _this.$message.success("关闭成功")
          })
        })
        .catch(() => { });
    },
    //closeAplCodeFn关闭apl编号
    closeAplCodeFn () {
      ApiMethods.UserApplySignController.signWriteAiSwitch({
        applyNo: this.aplCode,
        flag: 1,
      }).then(res => {
        if (res.success) {
          this.aplCode = '';
          this.closeAplCodeVisible = false;
          this.$message({
            type: "success",
            message: "关闭成功"
          });
        } else {
          this.$message({
            type: "error",
            message: res.description,
          });
        }
      })
    },
    flushImageCode () {
      var _this = this;
      _this.$nextTick(() => {
        _this.$refs.pwdSwithImgAuth.getImgAuth();
      });
    },
    // 设置签署密码状态
    setPWdSwitch () {
      this.$refs.pwdSwitch.validate(val => {
        if (val || val === "true") {
          let imgToken = this.$refs.pwdSwithImgAuth.imgAuth.imgToken,{signPwdFlag:flag}=this.signPwdInfo;
          let param = {
            signPwd: this.signPwdSwitchParam.signPwd,
            randomCode: `${imgToken}_${this.signPwdSwitchParam.imgCode}`,
            flag
          };

          SecurityController.signPwdSwitch(param)
            .then(() => {
              this.dialogVisible = false;
              this.selectSwitch = !!flag
              this.$message.success("签署密码状态设置成功");
            })
            .catch(err => {
              this.flushImageCode();
              this.$message.warning(err.description || "密码设置失败");
            });
        }
      });
    },
    // 取消设置签署密码状态
    handleCancelSwitch () {
      this.dialogVisible = false;
    },
    // 取消密码设置
    handleCancelSetPwd () {
      this.stepPwd = 1;
      this.isForget = false;
      this.countdown = { value: 120, start: false };
      this.setPwdParam = {
        targetId: "",
        signPwd: "",
        rSignPwd: "",
        imgCode: "",
        noteCode: "",
        ts: "",
        sign: ""
      };
    },
    // 保存签署密码
    saveSignPwd () {
      this.$refs.setPwdForm.validate(val => {
        if (val || val === "true") {
          let param = {
            signPwd: this.setPwdParam.signPwd,
            sign: this.setPwdParam.sign,
            ts: this.setPwdParam.ts
          };
          this.loadingStart("正在设置密码");

          SecurityController.signPwdSave(param)
            .then(data => {
              this.loadingClose();
              this.handleCancelSetPwd();
              this.selectSwitch=true
              this.$message.success("密码设置成功");
              this.getSignPwdInfo();
            })
            .catch(err => {
              this.loadingClose();
              this.handleCancelSetPwd();
              this.$message.warning(err.description || "密码设置失败");
            });
        }
      });
    },
    // 下一步 验证短信验证码，获取签名
    handleNextStap () {
      this.$refs.setPwdForm.validate(val => {
        if (val || val === "true") {
          var param = {
            valicode: this.setPwdParam.noteCode,
            verifyType: 11,
            targetId: this.signPwdInfo.mobile,
            ifDecode: 0
          };
          secSignInfo(param)
            .then(({ data }) => {
              this.setPwdParam.ts = data.ts;
              this.setPwdParam.sign = data.sign;
              this.stepPwd = 2;
            })
            .catch(err => {
              this.countdown = { value: 120, start: false };
              this.$message.info(
                err.description || "短信验证码不正确或已经失效"
              );
            });
        }
      });
    },
    // 处理开关切换
    handleSwitchChange (val) {
      this.signPwdInfo.signPwdFlag = val ? 1 : 0;
      if (this.signPwdInfo.signPwdStatus === 0) {
        this.$confirm("您还未设置签署密码，是否现在设置？", "系统提示", {
          type: "info"
        })
          .then(() => {
            this.isForget = true;
          })
          .catch(() => {});
      } else {
        this.signPwdSwitchParam = {
          signPwd: "",
          randomCode: "",
          flag: 0,
          imgCode: ""
        };
        this.dialogVisible = true;
      }
    },
    // 获取签署密码信息
    getSignPwdInfo () {
      this.loadingStart();
      SecurityController.signPwdInfo()
        .then(({ data }) => {
          this.loadingClose();
          this.signPwdInfo = data;
          // 测试用
          // this.setPwdParam.targetId = this.signPwdInfo.legalMobilePhone
          this.selectSwitch = this.signPwdInfo.signPwdFlag === 0 ? false : true;
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    // 发送验证码
    sendNoteAuthCode () {
      this.$refs.setPwdForm.validateField("imgCode", val => {
        if (val || val !== "") {
          return false;
        }

        let imgToken = this.$refs.setPwdImgAuth.imgAuth.imgToken;
        let noteParam = {
          targetId: this.signPwdInfo.mobile,
          verifyType: 11,
          imgCode: `${imgToken}_${this.setPwdParam.imgCode}`,
          ifDecode: 0
        };

        postSendCode(noteParam)
          .then(data => {
            this.countdown.value = 120;
            this.countdown.start = true;
          })
          .catch(err => {
            this.$refs.setPwdImgAuth.getImgAuth();
            this.setPwdParam.imgCode = "";
            this.$message.info(err.description || "验证码发送失败");
          });
      });
    },
    loadingStart (info = null) {
      this.loadingClose();
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    loadingClose () {
      if (this.loading) {
        this.loading.close();
      }
    },
    resPassword (rule, value, callback) {
      if (value === "") {
        callback("请输入确认密码");
      } else if (value !== this.setPwdParam.signPwd) {
        callback("两次输入的密码不一致");
      } else {
        callback();
      }
    }
  },
  name: "signPwd"
};
</script>

<style lang="less" scoped>
.title-label{
  font-size: 0.85vw;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.forget{
  font-size: 1vw;
  font-weight: 400;
  color: #ec1c1c;
  cursor: pointer;
  margin-left: 10px;
}

.img-code {
  display: inline-block;
  width: 100px;
}
.step1 {
  margin-top: 8px;
  .forget {
    cursor: pointer;
  }
}
.sign-pwd {
  padding: 0 20px;
  .hint {
    margin-top: 20px;
    color: #646464;
  }
}
.apl_code {
  padding: 20px;
  .flex_box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .lable {
      flex-shrink: 0;
    }
    .input {
      width: 300px;
      margin: 0 20px;
    }
  }
  .tip {
    color: #555555;
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/signPwd.vue